"use client";

import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { PlanningDashboard } from "./planning-dashboard";
import { Home } from "lucide-react";


interface PlanningWorkflowProps {
  initialTab?: string;
}

export function PlanningWorkflow({ initialTab }: PlanningWorkflowProps) {
  const [activeTab, setActiveTab] = useState(initialTab || "dashboard");

  const handleNavigateToWorkflow = (workflowId: string) => {
    // Since we removed the workflow tabs, this function is no longer needed
    // but we keep it for compatibility with the PlanningDashboard component
    console.log("Navigation to workflow:", workflowId);
  };

  return (
    <div className="bg-background min-h-screen p-6">
      <div className="mx-auto max-w-7xl">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-1">
            <TabsTrigger value="dashboard" className="flex items-center gap-2">
              <Home className="h-4 w-4" />
              Dashboard
            </TabsTrigger>
          </TabsList>

          <TabsContent value="dashboard" className="mt-6">
            <PlanningDashboard
              onNavigateToWorkflow={handleNavigateToWorkflow}
            />
          </TabsContent>

        </Tabs>
      </div>
    </div>
  );
}
